import { AutogenLayoutEquipmentTypeLookup } from "./autogen/AutogenLayoutEquipmentTypeLookup";
import { TableRow, TableRowDisplayEvent } from "@mcleod/components";

export class EquipmentTypeLookup extends AutogenLayoutEquipmentTypeLookup {

    tableEquipmentTypeOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.target as TableRow;
        const modelRow = tableRow.data;
        if (modelRow.get("sort_column", -1) == 0) {
            tableRow.fontBold = true;
            tableRow.backgroundColor = "success.lightest";
            tableRow.borderColor = "success.dark";
        }
    }
}
